/* eslint-disable react/prop-types */
import React from "react";
import { CardContainer } from "../../../components/Card";
import { BarChart, LineChart } from "../../../components/Charts";

export default function Engagement({ data }) {
    function prepareHistogramData(histogramData) {
        return histogramData.map((item, index, array) => {
            let range;
            if (index === 0) {
                range = `<${item.max.toFixed(2)}`;
            } else if (index === array.length - 1) {
                range = `>${item.min.toFixed(2)}`;
            } else {
                range = `${item.min.toFixed(2)}-${item.max.toFixed(2)}`;
            }
            return {
                range,
                total_profile_count: item.total_profile_count,
                is_median: item.is_median,
            };
        });
    }
    const preparedData = prepareHistogramData(data?.engagement_rate_histogram);
    return (
        <>
            <CardContainer className="export-section">
                <LineChart
                    data={data?.reputation_history}
                    series={[
                        {
                            name: "followers",
                            key: "followers",
                        },
                    ]}
                    xKey="month"
                    title="Followers"
                />
                <LineChart
                    data={data?.reputation_history}
                    series={[
                        {
                            name: "following",
                            key: "following",
                        },
                    ]}
                    xKey="month"
                    title="Following"
                />
            </CardContainer>
            <CardContainer className="export-section">
                <LineChart
                    data={data?.reputation_history}
                    series={[
                        {
                            name: "likes",
                            key: "likes",
                        },
                    ]}
                    xKey="month"
                    title="Likes"
                />
                <BarChart
                    data={preparedData}
                    series={[
                        {
                            name: "Total Profile Count",
                            key: "total_profile_count",
                        },
                    ]}
                    xKey="range"
                    title="Engagement Rate Histogram"
                    isCategoryX={true}
                />
            </CardContainer>
        </>
    );
}
